import { render } from "./EditAutocomplete.vue?vue&type=template&id=55d57cb1"
import script from "./EditAutocomplete.vue?vue&type=script&lang=ts"
export * from "./EditAutocomplete.vue?vue&type=script&lang=ts"

import "./EditAutocomplete.vue?vue&type=style&index=0&id=55d57cb1&lang=scss"
script.render = render

export default script